module.exports = __webpack_public_path__ + "static/media/one-invoice-logo.da30d474.svg";